import { render, staticRenderFns } from "./sendSingle.vue?vue&type=template&id=9657c706&"
import script from "./sendSingle.vue?vue&type=script&lang=js&"
export * from "./sendSingle.vue?vue&type=script&lang=js&"
import style0 from "./sendSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports